export default __webpack_public_path__ + "static/media/team49.57724f31.JPG";